/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");

import i18n from "./i18n";
import Vue from "vue";
import VueMeta from "vue-meta";
import router from "./router";
import store from "./store/index";
import BootstrapVue from "bootstrap-vue";
import axios from "axios";
import gematriya from "gematriya"; // for hebrew numerals
import Vuebar from "vuebar";
import VueLazyLoad from "vue-lazyload";
import Axios from "axios";
import { loadProgressBar } from "axios-progress-bar";
import "./libraries/ServerTables";
import "axios-progress-bar/dist/nprogress.css";

// import IpInfoService from "./libraries/IpInfoService";
// IpInfoService.getUserCountry();

Vue.prototype.$http = Axios;
Vue.use(BootstrapVue);
Vue.use(Vuebar);
Vue.use(VueMeta);
Vue.use(VueLazyLoad);
loadProgressBar();

const token = localStorage.getItem("token");
if (token) {
    Vue.prototype.$http.defaults.headers.common["Authorization"] =
        "Bearer " + token;
}

Vue.prototype.$http.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        // handle error
        if (error.response) {
            if (error.response.status == 404) {
                return router.push({
                    name: "404"
                });
            } else if (error.response.status == 500) {
                return router.push({
                    name: "500"
                });
            } else if (error.response.status == 403) {
                alert(error.response.data.message);
                return;
            }
            if (error.response.status === 401) {
                if (token) store.dispatch("auth/logout");
                return Promise.reject(error);
            } else {
                return router.push({
                    name: "error"
                });
            }
        }
    }
);

Vue.filter("gematriya", gematriya);

import App from "./views/Layout.vue";

const app = new Vue({
    el: "#app",
    router,
    i18n,
    store,
    render: h => h(App)
});
